export const logo =
  "https://firebasestorage.googleapis.com/v0/b/tsawq-244e3.appspot.com/o/Tsawq%20Logo%2Fsplash2.webp?alt=media&token=8f42b744-d824-4df9-b347-84714c43a645";
